import Gradient from "../Gradient";
import Laptoffee from "../../assets/images/laptoffee.png";
import Stone from "../../assets/images/stone.png";
import RotatingCircle from "../RotatingCircle";
import HeroSlider from "../HeroSlider";
import CalendlyCustomButton from "../CalendlyCustomButton";
import useBreakpoint from "../../hooks/useBreakpoints";

const HeroSection = ({ data }) => {
  const { mainTitle, subTitle, HeroSlides } = data;
  const { isLaptop } = useBreakpoint();

  return (
    <section className="section hero-section flex-wrapper">
      <div className="flex-container section-container">
        <div className="section-container__main">
          <div className="section-container__main-left">
            <h1>
              <span>{mainTitle}</span>
            </h1>
            <p>{subTitle}</p>
          </div>
          <div className="section-container__main-animation">
            <RotatingCircle />
            <img className="laptop-img" src={Laptoffee} alt="laptop" />
          </div>
        </div>

        <div className="hero-bottom">
          <HeroSlider slides={HeroSlides} />
          <div className="hero-bottom__right">
            <CalendlyCustomButton />
          </div>
        </div>
      </div>
      <div className="hero-stone">
        <img src={Stone} alt="stone" />
      </div>
      <Gradient
        imageName="gradient2"
        className="gradientRight"
        right="0px"
        bottom={isLaptop ? "100px" : 0}
        left="initial"
        size="contain"
        width="75vw"
        height="100vh"
      />
    </section>
  );
};

export default HeroSection;
